<template>
    <div class="calendar__datepicker">
        <component-datepicker
            @datepicker-selected="datepickerSelected"
        />
    </div>
</template>
<script>
import ComponentDatepicker from '@/components/default/shared/ComponentDatepicker'

export default {
  name: 'calendar-datepicker',
  components: {
    ComponentDatepicker
  },
  methods: {
    datepickerSelected: function (date) {
      const dateISO = new Date(date).toISOString()
      this.$emit('datepicker-selected', dateISO)
    }
  }
}
</script>
